import { Navigate } from "react-router-dom";
import { useDashboardStore } from "./store/dashboardStore";
import { useDashboardAccess } from "./api/queries";
import { HomeView } from "./views/HomeView";
import { FlowsView } from "./views/FlowsView";
import { FlowReportView } from "./views/FlowReportView";
import { BroadcastsView } from "./views/BroadcastsView";
import { BroadcastReportView } from "./views/BroadcastReportView";
import { EsteiraView } from "./views/EsteiraView";
import { EsteiraReportView } from "./views/EsteiraReportView";
import { ClicksView } from "./views/ClicksView";
import { CountriesView } from "./views/CountriesView";
import { NodeDrawer } from "./views/NodeDrawer";

// Entry point do módulo. UMA tela só com switch interno por view.name
// (replicando o handoff: tudo numa página, navegação por estado).
// Cada view monta seu próprio PageShell (precisa controlar o slot `hero`
// pra que a FilterBar fique ABAIXO do hero, conforme o design).
export default function Dashboard() {
    const view = useDashboardStore((s) => s.view);
    // Gate: colaborador sem `dashboard_view` em nenhuma page → redireciona
    // pra /meta/flow. Backend é a fonte da verdade (também bloqueia os
    // endpoints), o front só evita renderizar a página vazia/inerro.
    const { data: access, isLoading: accessLoading } = useDashboardAccess();
    if (!accessLoading && access?.enabled === false) {
        return <Navigate to="/meta/flow" replace />;
    }

    return (
        <div
            className="p-6 bg-gray-50 min-h-screen"
            style={{
                // Inter (carregada no index.html) escopada APENAS no Dashboard
                // pra não interferir com o resto do front-rocket. Tipografia
                // mais compacta que a default do sistema → bate com o mockup.
                fontFamily:
                    "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
            }}
        >
            {renderView(view.name, view.id, view.contentHash)}
            <NodeDrawer />
        </div>
    );
}

function renderView(
    name: string,
    id: string | undefined,
    contentHash: string | undefined
) {
    switch (name) {
        case "home":
            return <HomeView />;
        case "flows":
            return <FlowsView />;
        case "flow":
            return <FlowReportView flowId={id} />;
        case "broadcasts":
            return <BroadcastsView />;
        case "broadcast":
            return (
                <BroadcastReportView bcId={id} contentHash={contentHash} />
            );
        case "esteira":
            return <EsteiraView />;
        case "esteira_group":
            return <EsteiraReportView esId={id} />;
        case "cliques":
            return <ClicksView />;
        case "paises":
            return <CountriesView />;
        default:
            return <HomeView />;
    }
}
